import React from 'react';
import { Route, Redirect } from "react-router-dom";

type GuardedRouteType = {
    component: any,
    canAccess: boolean,
    props?:any
};

const GuardedRoute: React.FC<GuardedRouteType> = ({ component: Component, canAccess, props: componentProps, ...rest }) => {
    return <Route {...rest} render={(props) => (
        canAccess && Component
            ? <Component {...props} {...componentProps}/>
            : <Redirect to='/login' />
    )} />
}

export default GuardedRoute;
